import { Component } from '@angular/core';
import { MenuItem } from '../models/menu-item';

@Component({
    selector: 'app-menu-bar',
    templateUrl: './menu-bar.component.html',
    styleUrls: ['./menu-bar.component.sass'],
    standalone: false
})
export class MenuBarComponent {
  menuItems: MenuItem[] = [
    {
      routeId: 'users',
      route: 'users'
    },
    {
      routeId: 'organisations',
      route: 'organisations'
    }
  ]
}
